/** Production copy — PAGE 3: SERVICES */
export const SERVICES_HERO = {
    eyebrow: 'Our Services',
    h1: 'Strategic Consulting That Drives Revenue, Efficiency, and Growth',
    body: 'We work with mid-market and enterprise organizations to solve complex business challenges through technology, strategy, and disciplined execution. Every engagement is designed to deliver measurable, bottom-line results.',
}

export const SERVICES_FULL = [
    {
        id: 'digital-transformation',
        title: 'Digital Transformation Consulting',
        body: 'We lead end-to-end digital transformation programs — from strategy definition through full-scale implementation and adoption. We help organizations modernize legacy systems, implement new technology platforms, and fundamentally redesign business processes to compete in the digital economy.',
        included: [
            'Digital maturity assessment and benchmarking against industry standards',
            'Transformation roadmap with phased milestones and clear ROI targets',
            'Technology vendor evaluation, selection, and contract negotiation support',
            'Implementation project leadership from initiation through go-live',
            'Organizational change management to ensure adoption and minimize disruption',
            'Post-implementation optimization and continuous improvement framework',
        ],
        caseReference:
            'Our signature project: Leading a $6B+ core banking system transformation for Canada’s largest credit union merger — one of the most complex digital transformation programs in the country’s financial services history.',
        cta: 'Enquire About Digital Transformation',
        prefill: 'Digital Transformation Consulting',
    },
    {
        id: 'ai-strategy',
        title: 'AI Strategy & Implementation',
        body: 'We help organizations move from AI-curious to AI-powered. Whether you’re exploring your first AI use case or scaling AI across the enterprise, we design strategies that deliver real business value — not just proof-of-concept demos that go nowhere.',
        included: [
            'AI readiness assessment — evaluate your data, infrastructure, talent, and culture',
            'Use case identification and prioritization based on business impact and feasibility',
            'AI vendor and platform selection — build vs buy analysis',
            'Pilot program design, execution, and measurement',
            'AI governance framework — ethics, compliance, risk management',
            'Team training and upskilling — building internal AI capability',
        ],
        cta: 'Enquire About AI Strategy',
        prefill: 'AI Strategy & Implementation',
    },
    {
        id: 'process-optimization',
        title: 'Business Process Optimization',
        body: 'Inefficient processes are the silent revenue killer. We audit, redesign, and optimize your business processes to eliminate waste, reduce costs, increase speed, and improve quality. Our approach combines Lean, Six Sigma, and Agile methodologies with modern automation and AI tools to deliver lasting improvements.',
        included: [
            'Current-state process mapping and documentation',
            'Gap analysis and bottleneck identification',
            'Future-state process re-engineering',
            'Automation opportunity assessment and implementation',
            'KPI design and measurement dashboard creation',
            'Continuous improvement framework and governance model',
        ],
        cta: 'Enquire About Process Optimization',
        prefill: 'Business Process Optimization',
    },
    {
        id: 'business-analysis',
        title: 'Business Analysis & Requirements Management',
        body: 'Projects fail when requirements are unclear, incomplete, or poorly managed. We embed senior business analysts into your teams to bridge the gap between business needs and technology solutions. Our analysts don’t just document — they facilitate alignment, resolve conflicts, and drive clarity.',
        included: [
            'Stakeholder analysis and engagement planning',
            'Requirements elicitation workshops using interviews, observation, and document analysis',
            'Business requirements documentation (BRD) and functional specifications',
            'User stories, acceptance criteria, and definition of done',
            'Requirements traceability matrix and change management',
            'User acceptance testing (UAT) strategy, execution, and sign-off',
        ],
        cta: 'Enquire About Business Analysis',
        prefill: 'Business Analysis & Requirements Management',
    },
    {
        id: 'change-management',
        title: 'Change Management',
        body: 'Technology doesn’t fail. Adoption does. The most sophisticated systems in the world are useless if your people don’t use them. Our change management practice ensures your teams are informed, prepared, trained, and aligned with new systems and processes — before, during, and after go-live.',
        included: [
            'Change impact assessment — who is affected, how, and what support they need',
            'Stakeholder engagement and sponsorship strategy',
            'Communication plan — the right message to the right audience at the right time',
            'Training program design and delivery — role-based, practical, hands-on',
            'Adoption measurement and reinforcement — tracking actual usage, not just attendance',
            'Resistance management — identifying and addressing pushback before it derails the project',
        ],
        cta: 'Enquire About Change Management',
        prefill: 'Change Management',
    },
    {
        id: 'corporate-training',
        title: 'Corporate Training & Workforce Development',
        body: 'Your team’s capability is your competitive advantage. We design and deliver custom training programs that upskill your workforce in the areas that matter most: business analysis, AI and data literacy, agile project management, digital transformation, and leadership. Our programs are built for real-world application, not theoretical fluff.',
        included: [
            'Training needs assessment and skills gap analysis',
            'Custom curriculum design aligned to your organization’s specific challenges',
            'Live instructor-led training — virtual or in-person, interactive and practical',
            'On-demand learning modules for self-paced development',
            'Certification preparation for globally recognized credentials (IIBA, Scrum, Six Sigma)',
            'Post-training coaching and performance measurement',
        ],
        extraBody:
            'We’ve delivered training at every scale — from intimate executive workshops to programs reaching 100,000+ professionals. We’re also an IIBA Endorsed Education Provider and ScrumStudy Authorized Training Partner, so your team earns credentials that are recognized worldwide.',
        cta: 'Request a Corporate Training Proposal',
        prefill: 'Corporate Training',
    },
    {
        id: 'technology-consulting',
        title: 'Technology Consulting & Implementation',
        body: 'Technology investments should generate measurable ROI, not just shiny dashboards. From CRM and ERP implementations to cloud migration, custom software development, and system integration — we ensure your technology serves your business strategy, not the other way around.',
        included: [
            'Technology landscape audit and rationalization',
            'Platform selection and vendor evaluation',
            'Implementation project management and delivery leadership',
            'System integration and API development',
            'Data migration planning and execution',
            'Quality assurance, testing, and performance optimization',
        ],
        cta: 'Enquire About Technology Consulting',
        prefill: 'Technology Consulting & Implementation',
    },
    {
        id: 'talent-solutions',
        title: 'Talent Solutions',
        body: 'Great strategy requires great people. We recruit, place, and manage top global tech talent across industries. Whether you need a fractional CTO for six months, a team of business analysts for a transformation program, or a full project delivery squad — we have the network, the assessment methodology, and the management capability to deliver.',
        included: [
            'Talent sourcing from our global network of trained and certified professionals',
            'Technical and soft-skills assessment',
            'Permanent placement, contract-to-hire, and project-based staffing',
            'Team augmentation — plug-and-play resources into your existing teams',
            'Talent pipeline development for ongoing needs',
            'Managed services — we handle recruitment, onboarding, and performance management',
        ],
        cta: 'Discuss Your Talent Needs',
        prefill: 'Talent Solutions',
    },
]
